import React, { useState, useEffect} from "react";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import ActivePositions from "./activePositions";
import {
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useNavigate } from "react-router-dom";
import {
  applyPositionFilters,
  getAllocatedto,
  getCompany,
  getPositions,
  getpositionsName,
} from "./services";
import classnames from "classnames";
import crownIcon from "../../assets/images/crown_icon_fill.svg";
import { viewedpageMixpanel } from "../../utils/mixpanel";
import { getAPI } from "../../api/api";
import { REACT_APP_COMMON } from "../../utils/common";

function Positions() {
  const navigate = useNavigate();

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);
  const BreadcrumsValues = ["Positions"];
  const [filterNumber, setFilterNumber] = useState<number>();
  const [filterValues, setFilterValues] = useState<any>(null);
  const [companyList, setCompanyList] = useState<any>();
  const [selected, setSelected] = useState<number>(0);

  const [positions, setPositions] = useState<any>()
  const [myPositions, setMypositions] = useState<any>()
  const [draft, setDraft] = useState<any>()
  const [closed, setClosed] = useState<any>()
  const [activeTotal, setActiveTotal] = useState<number>()
  const [totalActivePositions, setTotalActivePositions] = useState<number>()
  const [myposTotal, setMyposTotal] = useState<number>()
  const [closedTotal, setClosedTotal] = useState<number>()
  const [draftTotal, setDraftTotal] = useState<number>()
  const [CSData, setCSData] = useState<any>();
  const [CSTotal, setCSTotal] = useState<number>()
  const [jobRoleList, setJobRoleList] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [positionName, setPositionName] = useState<any>()
  const [sort, setSort] = useState<any>([]);
  const findTab = (value: number) => {
    let val = "";
    switch (value) {
      case 0:
        return (val = "active");
        break;
      case 1:
        return (val = "myPosition");
        break;
      case 2:
        return (val = "closed");
        break;
      case 3:
        return (val = "draft");
        break;
      default:
        return (val = "active");
    }
  };

  const getCompanyList = () => {
    getCompany().then((response: any) => {
      if (response && response.status === 1) {
        setCompanyList(response.data.map((item:any) => item.companyName));
      }
    });
  };

  const getPositionName = () => {
    getpositionsName().then((response: any) => {
      if (response && response.status === 1) {
        setPositionName(response.data.map((item:any)=> item.title ? item.title : ''));
      }
    });
  };

  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  useEffect(() => {
    getAllPositions("active", 1, 25, "","");
    getAllPositions("myPosition", 1, 25, "","");
    getAllPositions("closed", 1, 25, "","");
    getAllPositions("draft", 1, 25, "", "");
    getAllPositions('CSPositions', 1, 25, "");
    getAllocation();
    getCompanyList();
    getPositionName();
    viewedpageMixpanel();

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

  }, []);


  const getAllPositions = (
    positionType: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any,
    sort?:any
  ) => {
  

  let data = {};
  let sortfilter={};
  if(sort)
  {
    if(sort.length!==0)
    {
       sortfilter={
        sortBy:sort[0].field,
        sortOrder:sort[0].dir    
      }
    }
  }
  
    if (filters) { 
      // filters.crowdSourcingEnabled = 'true'

    if( Object.keys(sortfilter).length===0)
    {
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
        filters,
      }
    }
    else
    {
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
        filters,
        sort:sortfilter
      }
    }
  
   }else{
    if( Object.keys(sortfilter).length===0)
    {
      data = {
        positionType: positionType === 'CSPositions' ? 'active' : positionType,
        login_id: localStorage.getItem('loginId'),
        filters: positionType === 'CSPositions' ?
        {
          crowdSourcingEnabled:'true'
        } : undefined
      }
    }
    else
    {
      data = {
        positionType: positionType === 'CSPositions' ? 'active' : positionType,
        login_id: localStorage.getItem('loginId'),
        sort: sortfilter,
        filters: positionType === 'CSPositions' ?
        {
          crowdSourcingEnabled:'true'
        } : undefined
      }
    }
  }

    getPositions(searchValue , pageNumber, pageSize, data).then((resp) => { 
      if (resp && resp.status === 1) {  
        switch(positionType){
          case 'active':
            setPositions(resp.data)     
            setActiveTotal(resp.totalPositionsCountWithFilter)
            if(filters){      
              setTotalActivePositions(resp.totalPositionsCountWithFilter)
            }else{
              setTotalActivePositions(resp.totalActivePositionsCountWithoutFilters)
            }
            break;
          case "myPosition":
            setMypositions(resp.data);
            setMyposTotal(resp.totalPositionsCountWithFilter);
            break;
          case "closed":
            setClosed(resp.data);
            setClosedTotal(resp.totalPositionsCountWithFilter);
            break;
          case "draft":
            setDraft(resp.data);
            setDraftTotal(resp.totalPositionsCountWithFilter);
            break;
          case "CSPositions":
            setCSData(resp.data);
            setCSTotal(resp.totalPositionsCountWithFilter)
        }
      }
    });
  };

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const searchChange = (e: string) => {
    getAllPositions("active", 1, 25, e, filterValues);
    getAllPositions("myPosition", 1, 25, e, filterValues);
    getAllPositions("closed", 1, 25, e, filterValues);
    getAllPositions("draft", 1, 25, e, filterValues);
    getAllPositions('CSPositions', 1, 25, e, filterValues);

  };

  const getPosition = (pageSize: any, pageNumber: number) => {
    
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
    getAllPositions(findTab(selected), page, pageSize, "", filterValues,sort);
    
  };

  const applyFilter = (data: any) => {

    getAllPositions("active", 1, 25, "", data.filters,sort);
    getAllPositions("myPosition", 1, 25, "", data.filters,sort);
    getAllPositions("closed", 1, 25, "", data.filters,sort);
    getAllPositions("draft", 1, 25, "", data.filters, sort);
    getAllPositions('CSPositions', 1, 25, "", data.filters, sort);

    delete data.positionStatusCombination
    delete data.filters.crowdSourcingEnabled    
    setFilterValues(data.filters);
   
  };

  const applySort = (sort: any) => {

    getAllPositions("active", 1, 25, "", filterValues,sort);
    getAllPositions("myPosition", 1, 25, "", filterValues,sort);
    getAllPositions("closed", 1, 25, "", filterValues,sort);
    getAllPositions("draft", 1, 25, "", filterValues,sort);
    getAllPositions('CSPositions', 1, 25, "", filterValues, sort);

  };
  const closeTag = (data: any) => { 
    if (
      Object.values(data).every((item) => {
        if (item === undefined) {
          return true;
        }
      }) === false
    ) {
      let value = {
        positionType: "active",
        filters: data,
      };
      applyFilter(value);
    } else {
      let value = {
        positionType: "active",
      };
      applyFilter(value);
    }
  };

  const ActiveTab = <>Active <i>{activeTotal}</i></>;
  const MyPositionTab = <>My Position <i>{myposTotal}</i></>;
  const ClosedTab = <>Closed <i>{closedTotal}</i></>;
  const DraftTab = <>Draft <i>{draftTotal}</i></>;
  const CSTab = <>Crowdsourcing <i>{CSTotal}</i></>;
  const pageChange = () => {
    getAllPositions(findTab(selected), 1, 25, "", filterValues,sort);
  };

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyFilter={applyFilter}
          companyList={companyList}
          allocatedTo={allocatedTo}
          filterNumber={filterNumber}
          navigateTo="../createPositions"
          searchChange={searchChange}
          closeTag={closeTag}
          filterValues={filterValues}
          positionName={positionName}
          type='positions'
          jobRolesList={jobRoleList}
        />
        <section className={Styles.positionWrapper}>
          <div className={Styles.activePositions}>
            <img src={crownIcon}/>Active positions<span>{totalActivePositions}</span></div>          
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title={ActiveTab} >
              <ActivePositions setSort={setSort} applySort={applySort} positions={positions} total={activeTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
              <Tab title={MyPositionTab}>
                <ActivePositions setSort={setSort} applySort={applySort} positions={myPositions} total={myposTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
              <Tab title={ClosedTab}>
                  <ActivePositions setSort={setSort} applySort={applySort} positions={closed} total={closedTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
              <Tab title={DraftTab}>
                  <ActivePositions setSort={setSort} applySort={applySort} draftKey={'draftKey'} positions={draft} total={draftTotal} getTableValues={pageChange} pageSize={getPosition}/>
            </Tab>
            <Tab title={CSTab}>
                <ActivePositions setSort={setSort} applySort={applySort}  positions={CSData} total={CSTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  );
}

export default Positions;
